import { MarketCountryCode } from '@backmarket/http-api'

export const YOUTUBE_VIDEO_IDS: Partial<Record<MarketCountryCode, string>> = {
  [MarketCountryCode.FR]: 'XoW1Svpwrsc',
  [MarketCountryCode.BE]: 'XoW1Svpwrsc',
  [MarketCountryCode.GB]: 'WeDcl9ZK3yg',
  [MarketCountryCode.US]: 'WeDcl9ZK3yg',
}
